import { SET_RESOURCE_LIST } from '../constants/Resource';

export const setResourceList = (resourceList) => {
  console.log('action setResourceList');
  return {
    type: SET_RESOURCE_LIST,
    resourceList
  };
};
